import React from 'react';
import './App.css';
import ChatApp from './ChatApp'

function App() {
    return (
        <div className='App'>
            <header />
            <main>
                <ChatApp />
            </main>
        </div>
    )
}

export default App;